export const MENU_TITLE_OVERRIDE: Record<string, string> = {
  ui: 'User Interface',
  debug: 'Monitoring and Debugging',
}
